import { motion } from "framer-motion";
import Logo from "./Logo";

const Navbar = () => {
  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="relative z-50 bg-transparent py-6"
    >
      <nav className="mx-auto flex max-w-7xl items-center px-5 sm:px-8">
        <a href="#top" data-testid="nav-logo" aria-label="eurikaa home">
          <Logo markClass="h-6 w-auto sm:h-7" textClass="text-xl sm:text-2xl" />
        </a>
      </nav>
    </motion.header>
  );
};

export default Navbar;
